import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/documents/images/rotate/{documentId}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const updateImageOrientation = async ({ documentId, direction }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/documents/images/rotate/{documentId}', { documentId });
  const response = await documentApiClient.put(path, {
    direction,
  });
  return response.data;
};

export default updateImageOrientation;
